import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const CashupReport: React.FC = () => (
  <ReportPageShell
    reportType="cashup"
    title="Z / Cash-up Report"
    subtitle="Closed device sessions with per-tender expected vs declared and variance. Window is on session close date — open sessions are excluded."
    maxRangeDays={92}
    bullets={[
      'Session Number',
      'Closed At',
      'Opening Cash',
      'Total Sales',
      'Tender + Type',
      'Expected, Declared, Variance',
    ]}
  />
);

export default CashupReport;
